export const SELECT_TOOLBAR_ITEM = 'select-toolbar-item';

export const selectToolbarItem = props => ({
    ...props,
    type: SELECT_TOOLBAR_ITEM
});
